import _ from 'lodash';
import { axiosInstance } from '../helpers/axios';
import { userService } from './user.service';

export const educationTaxonomyService = {
  findAll,
  create,
  update,
  deactivate,
};

function findAll(query = {}) {
  return axiosInstance.get('/education-taxonomy', { params: query }).then(handleResponse).catch(handleError);
}

function create(item) {
  return axiosInstance.post('/education-taxonomy', item).then(handleResponse).catch(handleError);
}

function update(id, item) {
  return axiosInstance.patch(`/education-taxonomy/${id}`, item).then(handleResponse).catch(handleError);
}

function deactivate(id) {
  return axiosInstance.delete(`/education-taxonomy/${id}`).then(handleResponse).catch(handleError);
}

function handleError(error) {
  if (error && error.response) return handleResponse(error.response);
  throw error;
}

function handleResponse(response) {
  const data = response.data;
  if (!_.includes([200, 201, 204], response.status)) {
    if (response.status === 401) {
      userService.logout().then(() => window.location.reload(true));
    }
    const error = (data && data.message) || response.statusText;
    // eslint-disable-next-line no-throw-literal
    throw { status: response.status, error };
  }
  return data;
}
